import { AutoMap } from "@automapper/classes";
import { BaseDOM } from "./base.dom";

export class Operator extends BaseDOM<Operator> {
    @AutoMap()
    Position!: number;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;

}